var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { on: { submit: _vm.submit } },
    [
      _c("ValidationObserver", {
        ref: "inputObserver",
        attrs: { tag: "div" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(InputObserver) {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                        attrs: { cols: "12", sm: "12", md: "4" }
                      },
                      [
                        _c(
                          "v-sheet",
                          {
                            staticClass: "pt-3 pb-3 ",
                            attrs: { color: "grey lighten-3" }
                          },
                          [
                            _c(
                              "label",
                              { staticClass: "mb-0 font-weight-bold ml-4" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.contract_form.update.label.apply_info.apply_date"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                        attrs: { cols: "12", sm: "12", md: "3" }
                      },
                      [
                        _c("label", { staticClass: "apply-date" }, [
                          _vm._v(_vm._s(_vm.getApplyDate()))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-row",
                  { staticClass: "pt-0 mt-0" },
                  [
                    _c(
                      "v-expansion-panels",
                      {
                        attrs: {
                          accordion: "",
                          popout: "",
                          flat: "",
                          tile: "",
                          multiple: ""
                        },
                        model: {
                          value: _vm.form.applyService,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "applyService", $$v)
                          },
                          expression: "form.applyService"
                        }
                      },
                      [
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showKobetsuTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "kinoKunrenService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.kino_kunren"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.kinoKunren,
                                                    callback: function($$v) {
                                                      _vm.kinoKunren = $$v
                                                    },
                                                    expression: "kinoKunren"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _vm.isKobetuPlanSelectable()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-0" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: { cols: "12" }
                                          },
                                          [
                                            _c("v-img", {
                                              staticClass: "mx-auto",
                                              attrs: {
                                                src:
                                                  "/static/price_sample_training.png",
                                                width: "50%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _vm.isKobetuPlanSelectable()
                                          ? _c("ValidationProvider", {
                                              attrs: {
                                                vid: "kinoKunrenPeriod",
                                                rules: _vm.getKinoKunrenRule()
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(checked) {
                                                      return [
                                                        _c(
                                                          "v-radio-group",
                                                          {
                                                            staticClass:
                                                              "mt-0 pt-0 pb-0",
                                                            attrs: {
                                                              "persistent-hint": true,
                                                              "error-messages": _vm.getMessage(
                                                                checked.errors,
                                                                "required",
                                                                "apply_info.period"
                                                              ),
                                                              hint: _vm.$t(
                                                                "view.contract_form.update.hint.apply_info.period"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .kinoKunrenPeriod,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "kinoKunrenPeriod",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.kinoKunrenPeriod"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.$t(
                                                              "view.contract_form.update.data_labels.apply_info.period"
                                                            ),
                                                            function(
                                                              data_label
                                                            ) {
                                                              return _c(
                                                                "v-radio",
                                                                {
                                                                  key:
                                                                    "kino-kunren-period-" +
                                                                    data_label.value,
                                                                  attrs: {
                                                                    value:
                                                                      data_label.value,
                                                                    label:
                                                                      data_label.label
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getKobetuPlanName()
                                                  )
                                                )
                                              ])
                                            ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.apply_capacity"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _vm.showCapacityRadio()
                                          ? _c("ValidationProvider", {
                                              attrs: {
                                                vid: "applyCapacity",
                                                rules: _vm.getKinoKunrenRule()
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(checked) {
                                                      return [
                                                        _c(
                                                          "v-radio-group",
                                                          {
                                                            staticClass:
                                                              "mt-0 pt-0 pb-0",
                                                            attrs: {
                                                              "error-messages": _vm.getMessage(
                                                                checked.errors,
                                                                "required",
                                                                "apply_info.apply_capacity"
                                                              ),
                                                              "persistent-hint": true,
                                                              hint: _vm.$t(
                                                                "view.contract_form.update.hint.apply_info.apply_capacity"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .applyCapacity,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "applyCapacity",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.applyCapacity"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.$t(
                                                              "view.contract_form.update.data_labels.apply_info.apply_capacity"
                                                            ),
                                                            function(
                                                              data_label
                                                            ) {
                                                              return _c(
                                                                "v-radio",
                                                                {
                                                                  key:
                                                                    "kino-kunren-apply-capacity-" +
                                                                    data_label.value,
                                                                  attrs: {
                                                                    value:
                                                                      data_label.value,
                                                                    label:
                                                                      data_label.label
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.showCapacityRadio()
                                          ? [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(_vm.form.applyCapacity)
                                                )
                                              ])
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "kinoKunrenStartDate",
                                            rules: _vm.getKinoKunrenRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-01-01",
                                                        max: "2023-03-31"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .kinoKunrenStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "kinoKunrenStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.kinoKunrenStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowKobetuPlanPeriod()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.apply_info.plan_period"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-4 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "3"
                                            }
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getKobetuPlanPeriod()
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isShowKobetuPrice()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.apply_info.price"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-4 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "8"
                                            }
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(_vm.getKobetuPrice())
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isShowKobetuTokubetuDetail()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.contract.tokubetu_detail"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-2 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "8"
                                            }
                                          },
                                          [
                                            _vm.isShowKobetuBikoLink()
                                              ? _c("tokubetu-detail-link", {
                                                  attrs: {
                                                    title:
                                                      _vm.form
                                                        .kobetuPriceBook2Description,
                                                    href:
                                                      _vm.form
                                                        .kobetuPriceBookUrl
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("label", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getBikoHtml(
                                                    _vm.form
                                                      .kobetuTokubetuDetail
                                                  )
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showOralCareTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "oralCareService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    "hide-details": "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    )
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.oral_care"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.oralCare,
                                                    callback: function($$v) {
                                                      _vm.oralCare = $$v
                                                    },
                                                    expression: "oralCare"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _vm.isOralCarePlanSelectable()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-0" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: { cols: "12" }
                                          },
                                          [
                                            _c("v-img", {
                                              staticClass: "mx-auto",
                                              attrs: {
                                                src:
                                                  "/static/price_sample_oral_care.png",
                                                width: "50%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _vm.isOralCarePlanSelectable()
                                          ? _c("ValidationProvider", {
                                              attrs: {
                                                vid: "oralCarePeriod",
                                                rules: _vm.getOralCareRule()
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(checked) {
                                                      return [
                                                        _c(
                                                          "v-radio-group",
                                                          {
                                                            staticClass:
                                                              "mt-0 pt-0 pb-0",
                                                            attrs: {
                                                              "persistent-hint": true,
                                                              hint: _vm.$t(
                                                                "view.contract_form.update.hint.apply_info.period"
                                                              ),
                                                              "error-messages": _vm.getMessage(
                                                                checked.errors,
                                                                "required",
                                                                "apply_info.period"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .oralCarePeriod,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "oralCarePeriod",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.oralCarePeriod"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.$t(
                                                              "view.contract_form.update.data_labels.apply_info.period"
                                                            ),
                                                            function(
                                                              data_label
                                                            ) {
                                                              return _c(
                                                                "v-radio",
                                                                {
                                                                  key:
                                                                    "kino-kunren-period-" +
                                                                    data_label.value,
                                                                  attrs: {
                                                                    value:
                                                                      data_label.value,
                                                                    label:
                                                                      data_label.label
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getOralCarePlanName()
                                                  )
                                                )
                                              ])
                                            ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "oralCareSstartDate",
                                            rules: _vm.getOralCareRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-01-01",
                                                        max: "2023-03-31"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .oralCareSstartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "oralCareSstartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.oralCareSstartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowOralCarePlanPeriod()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.apply_info.plan_period"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-4 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "3"
                                            }
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getOralCarePlanPeriod()
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isShowOralCarePrice()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.apply_info.price"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-4 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "8"
                                            }
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(_vm.getOralCarePrice())
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isShowOralCareTokubetuDetail()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.contract.tokubetu_detail"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-2 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "8"
                                            }
                                          },
                                          [
                                            _vm.isShowOralCareBikoLink()
                                              ? _c("tokubetu-detail-link", {
                                                  attrs: {
                                                    title:
                                                      _vm.form
                                                        .oralCarePriceBook2Description,
                                                    href:
                                                      _vm.form
                                                        .oralCarePriceBookUrl
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("label", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getBikoHtml(
                                                    _vm.form
                                                      .oralCareTokubetuDetail
                                                  )
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showBasicTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "basicService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.basic"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.basic,
                                                    callback: function($$v) {
                                                      _vm.basic = $$v
                                                    },
                                                    expression: "basic"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(_vm.getBasicPlanName())
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.apply_capacity"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form.applyCapacityBasic
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "BasicStartDate",
                                            rules: _vm.getBasicRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        disabled: "",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-04-01"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .basicStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "basicStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.basicStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.getBasicPlanPeriod())
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.getBasicPrice()))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowKobetuTokubetuDetail()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.contract.tokubetu_detail"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-2 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "8"
                                            }
                                          },
                                          [
                                            _vm.isShowBasicBikoLink()
                                              ? _c("tokubetu-detail-link", {
                                                  attrs: {
                                                    title:
                                                      _vm.form
                                                        .basicPriceBook2Description,
                                                    href:
                                                      _vm.form.basicPriceBookUrl
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("label", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getBikoHtml(
                                                    _vm.form.basicTokubetuDetail
                                                  )
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showStandardTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "standardService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.standard"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.standard,
                                                    callback: function($$v) {
                                                      _vm.standard = $$v
                                                    },
                                                    expression: "standard"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(_vm.getStandardPlanName())
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.apply_capacity"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form.applyCapacityStandard
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "StandardStartDate",
                                            rules: _vm.getStandardRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        disabled: "",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-04-01"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .standardStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "standardStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.standardStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.getStandardPlanPeriod())
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.getStandardPrice()))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowKobetuTokubetuDetail()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.contract.tokubetu_detail"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-2 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "8"
                                            }
                                          },
                                          [
                                            _vm.isShowStandardBikoLink()
                                              ? _c("tokubetu-detail-link", {
                                                  attrs: {
                                                    title:
                                                      _vm.form
                                                        .standardPriceBook2Description,
                                                    href:
                                                      _vm.form
                                                        .standardPriceBookUrl
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("label", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getBikoHtml(
                                                    _vm.form
                                                      .standardTokubetuDetail
                                                  )
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showUpgradeToStandardTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "standardService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.upgrade_to_standard"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.upgradeToStandard,
                                                    callback: function($$v) {
                                                      _vm.upgradeToStandard = $$v
                                                    },
                                                    expression:
                                                      "upgradeToStandard"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.upgrade_to_standard_plan"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.form.upgradeToStandardFamilyName &&
                                    _vm.form.upgradeToStandardFamilyName.length
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.form
                                              .upgradeToStandardFamilyName,
                                            function(item, key) {
                                              return _c(
                                                "v-col",
                                                {
                                                  key: key,
                                                  staticClass:
                                                    "mb-0 mt-0 pt-2 pb-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "12",
                                                    md: "12"
                                                  }
                                                },
                                                [
                                                  item.familyName ===
                                                    "個別機能訓練加算" ||
                                                  item.familyName ===
                                                    "Rehab Cloud Basic"
                                                    ? [
                                                        _c("label", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.familyName +
                                                                "　契約終了日：" +
                                                                _vm.form
                                                                  .upgradeToStandardBaseContractEndDate
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    : [
                                                        _c("label", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.familyName
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _c(
                                          "div",
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "mb-0 mt-0 pt-2 pb-0",
                                                attrs: {
                                                  cols: "12",
                                                  sm: "12",
                                                  md: "8"
                                                }
                                              },
                                              [
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.upgradeToStandardPlanName +
                                                          "　契約終了日：" +
                                                          _vm.form
                                                            .upgradeToStandardBaseContractEndDate
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                "Rehab Cloud アップグレード " +
                                                  _vm.form
                                                    .standardProductPlanName
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "StandardStartDate",
                                            rules: _vm.getUpgradeToStandardRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-04-01",
                                                        max:
                                                          _vm.form
                                                            .upgradeToStandardBaseContractEndDate
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .standardStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "standardStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.standardStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.getStandardPlanPeriod())
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.getStandardPrice()))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showAdditionalTableTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "additionalTabletService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.additional_tablet"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.additionalTablet,
                                                    callback: function($$v) {
                                                      _vm.additionalTablet = $$v
                                                    },
                                                    expression:
                                                      "additionalTablet"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "view.contract_form.update.label.fixed_text.additional_tablet_plan_name"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "AdditionalTabletStartDate",
                                            rules: _vm.getAdditionalTabletRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        disabled: true,
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-05-01"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .additionalTabletStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "additionalTabletStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.additionalTabletStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getAdditionalTabletPlanPeriod()
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "申込みタブレット販売価格合計"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("v-data-table", {
                                          attrs: {
                                            hover: true,
                                            "hide-default-footer": "",
                                            "disable-sort": "",
                                            headers: _vm.tabletHeaders,
                                            items: _vm.tabletItems
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "item",
                                                fn: function(ref) {
                                                  var item = ref.item
                                                  return [
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.form
                                                              .displayDataTableObj[
                                                              "rehabCloudTabletInitialFeeText"
                                                            ]
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "¥" +
                                                              _vm.form.displayDataTableObj[
                                                                "rehabCloudTabletInitialFeeMonthly"
                                                              ].toLocaleString()
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.form
                                                              .additionalTablets
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "¥" +
                                                              _vm.form.displayDataTableObj[
                                                                "initialFeeTotalPrice"
                                                              ].toLocaleString() +
                                                              "（初月のみ）"
                                                          )
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.form
                                                              .displayDataTableObj[
                                                              "rehabCloudTabletText"
                                                            ]
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "¥" +
                                                              _vm.form.displayDataTableObj[
                                                                "rehabCloudTabletMonthly"
                                                              ].toLocaleString()
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.form
                                                              .additionalTablets
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "¥" +
                                                              _vm.form.displayDataTableObj[
                                                                "tabletsTotalPrice"
                                                              ].toLocaleString()
                                                          )
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showMotionAiTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "motionAiService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.motion_ai"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.motionAi,
                                                    callback: function($$v) {
                                                      _vm.motionAi = $$v
                                                    },
                                                    expression: "motionAi"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(_vm.getMotionAiPlanName())
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "MotionStartDate",
                                            rules: _vm.getMotionAiRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        disabled: "",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-06-01"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .motionAiStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "motionAiStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.motionAiStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.getMotionAiPlanPeriod())
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.getMotionAiPrice()))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowKobetuTokubetuDetail()
                                  ? _c(
                                      "v-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-0 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "pt-3 pb-3 align-center fixed-label-area",
                                                attrs: {
                                                  color: "grey lighten-3"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold ml-4 fixed-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "view.contract_form.update.label.contract.tokubetu_detail"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mb-0 mt-0 pt-2 pb-0",
                                            attrs: {
                                              cols: "12",
                                              sm: "12",
                                              md: "8"
                                            }
                                          },
                                          [
                                            _vm.isShowBasicBikoLink()
                                              ? _c("tokubetu-detail-link", {
                                                  attrs: {
                                                    title:
                                                      _vm.form
                                                        .basicPriceBook2Description,
                                                    href:
                                                      _vm.form.basicPriceBookUrl
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("label", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getBikoHtml(
                                                    _vm.form.basicTokubetuDetail
                                                  )
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showOldStandardTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "oldStandardService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.old_standard"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.oldStandard,
                                                    callback: function($$v) {
                                                      _vm.oldStandard = $$v
                                                    },
                                                    expression: "oldStandard"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getOldStandardPlanName()
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.apply_capacity"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form
                                                  .applyCapacityOldStandard
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("date-picker-wrapper", {
                                          attrs: {
                                            classes: "mt-0 pt-0 pb-0",
                                            disabled: "",
                                            hint: _vm.$t(
                                              "view.contract_form.update.hint.apply_info.start_date"
                                            ),
                                            type: "month"
                                          },
                                          model: {
                                            value:
                                              _vm.form.oldStandardStartDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "oldStandardStartDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.oldStandardStartDate"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getOldStandardPlanPeriod()
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.getOldStandardPrice())
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showEntryTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "entryService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.entry"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.entry,
                                                    callback: function($$v) {
                                                      _vm.entry = $$v
                                                    },
                                                    expression: "entry"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(_vm.getEntryPlanName())
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "EntryStartDate",
                                            rules: _vm.getEntryRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        disabled: "",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-04-01"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .entryStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "entryStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.entryStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.getEntryPlanPeriod())
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.getEntryPrice()))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showMediumTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "mediumService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.medium"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.medium,
                                                    callback: function($$v) {
                                                      _vm.medium = $$v
                                                    },
                                                    expression: "medium"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(_vm.getMediumPlanName())
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.apply_capacity"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form.applyCapacityMedium
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "MediumStartDate",
                                            rules: _vm.getMediumRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        disabled: "",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-04-01"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .mediumStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "mediumStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.mediumStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.getMediumPlanPeriod())
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.getMediumPrice()))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showProfessionalTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "professionalService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.professional"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.professional,
                                                    callback: function($$v) {
                                                      _vm.professional = $$v
                                                    },
                                                    expression: "professional"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getProfessionalPlanName()
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.apply_capacity"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form
                                                  .applyCapacityProfessional
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "ProfessionalStartDate",
                                            rules: _vm.getProfessionalRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        disabled: "",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-04-01"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .professionalStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "professionalStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.professionalStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getProfessionalPlanPeriod()
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.getProfessionalPrice())
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expansion-panel",
                          { attrs: { readonly: "" } },
                          [
                            _vm.showtoUpgradeTab
                              ? _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "pa-0 mt-0" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        vid: "toUpgradeService",
                                        rules: _vm.getApplyServiceRule()
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(checked) {
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: "true",
                                                    readonly: "",
                                                    "error-messages": _vm.getMessage(
                                                      checked.errors,
                                                      "required",
                                                      "",
                                                      "applyInfoApplyService"
                                                    ),
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "label",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "apply-service-label text-black font-weight-bold subtitle-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "view.contract_form.update.label.apply_info.upgrade"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.toUpgrade,
                                                    callback: function($$v) {
                                                      _vm.toUpgrade = $$v
                                                    },
                                                    expression: "toUpgrade"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                checked.errors.length
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ml-1 mt-0 pt-0 "
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "theme--light v-messages error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getMessage(
                                                                      checked.errors,
                                                                      "required",
                                                                      "",
                                                                      "applyInfoApplyService"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.current_plan"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: {
                                          cols: "12",
                                          sm: "12",
                                          md: "12"
                                        }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.isShowToUpgradeLimitedPreviousPlanName() +
                                                  "　契約終了日：" +
                                                  _vm.form
                                                    .currentContractEndDate
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    ),
                                    _vm._v(">\n                        ")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.upgrade_plan"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.isShowToUpgradeLimitedAfterPlanName()
                                              )
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3  align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold fixed-label ml-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.apply_capacity"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-2 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(_vm.form.toUpgradeCapacity)
                                            )
                                          ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.start_date"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "ToUpgradeStartDate:",
                                            rules: _vm.getToUpgradeRule()
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(checked) {
                                                  return [
                                                    _c("date-picker-wrapper", {
                                                      attrs: {
                                                        classes:
                                                          "mt-0 pt-0 pb-0",
                                                        disabled: "",
                                                        hint: _vm.$t(
                                                          "view.contract_form.update.hint.apply_info.start_date"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "view.contract_form.update.placeholder.apply_info.start_date"
                                                        ),
                                                        error: _vm.getMessage(
                                                          checked.errors,
                                                          "required",
                                                          "apply_info.start_date"
                                                        ),
                                                        type: "month",
                                                        min: "2023-04-01"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .toUpgradeStartDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "toUpgradeStartDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.toUpgradeStartDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.plan_period"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "3" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.form.toUpradePlanPeriodStr
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-0 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "pt-3 pb-3 align-center fixed-label-area",
                                            attrs: { color: "grey lighten-3" }
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "mb-0 font-weight-bold ml-4 fixed-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "view.contract_form.update.label.apply_info.price"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-0 mt-0 pt-4 pb-0",
                                        attrs: { cols: "12", sm: "12", md: "8" }
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.getUpgradePrice()))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-row",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ml-3 mb-0 mt-0 pt-3 pb-0",
                        attrs: { cols: "12", sm: "12", md: "4" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { depressed: "", type: "button" },
                            on: { click: _vm.back }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "view.contract_form.update.button_caption.back_to_office"
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass: "mb-0 mt-0 pt-3 pb-0",
                        attrs: { cols: "12", sm: "12", md: "4" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              depressed: "",
                              block: true,
                              type: "submit",
                              color: "#11479B",
                              dark: true
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "view.contract_form.update.button_caption.to_request_info"
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-085bb37e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-085bb37e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contract_form/ApplyInfo.vue
// module id = hbSr
// module chunks = 1